import Icon1 from "../../../../../assets/images/png/courses/icons/icon1.svg";
import Icon2 from "../../../../../assets/images/png/courses/icons/icon2.svg";
import Icon3 from "../../../../../assets/images/png/courses/icons/icon3.svg";
import Icon4 from "../../../../../assets/images/png/courses/icons/icon4.svg";

import Icon10 from "../../../../../assets/images/png/courses/icons/icon10.svg";
import Icon8 from "../../../../../assets/images/png/courses/icons/icon8.svg";
import Icon9 from "../../../../../assets/images/png/courses/icons/icon9.svg";

import Testimony2 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/liyide.webp";

import AlunmiImage from "../../../../../assets/images/svg/incubation.svg";
import LearnImage from "../../../../../assets/images/svg/intensive-learning.svg";
import BuildingImage from "../../../../../assets/images/svg/internship.svg";
import SupportImage from "../../../../../assets/images/svg/people-primary.svg";

export const techSalesProProgram = {
  id: 1,
  tag: "FOR STARTERS",
  title: "Tech Sales Pro Bootcamp",
  seoTitle: "Tech Sales Bootcamp Nigeria | Launch a Career in Tech Sales",
  description: `
  Imagine having a job where you get to introduce the coolest new tech to 
  businesses! That's what a career in tech sales is all about. With our Tech Sales 
  Bootcamp, you'll be learning how to sell for the future.
    `,
  metatags: `Break into tech sales with Utiva's intensive bootcamp. Learn B2B sales strategy, CRM tools, prospecting, and closing. Get hired faster with Africa's top tech sales training.`,
  duration: "12 Weeks",

  downloadBrochureUrl:
    "https://drive.google.com/file/d/1AKc0M1PXsZiP-jyp7hqwirmFCrtACjA2/view?usp=sharing",

  courseFormUrl: "courses/tech-sales-bootcamp/fill-form",

  jobTitle: "Tech Sales",

  kickoffDate: "December 2",
  kickoffTime: (
    <>
      Saturday 10:00 AM - 1:00 PM WAT
      <br />
      Sunday 2:00 PM - 5:00 PM WAT
    </>
  ),

  testimonial: {
    image: Testimony2,
    name: "Ajibola Liyide",
    role: "Internal, External and Media Relations",
    testimony: `
    The Utiva training with Utiva has been challenging and inspiring. 
    Challenging because it is at the same time as the re-branding project in 
    my office. Inspiring because I have learnt a lot so far. The key point 
    is that the user experience is the most important factor to add value and 
    provide solutions. `,
    starRating: "5.0",
  },

  courseOverview: {
    title: `Become a Tech Sales Expert`,
    desc: (
      <>
        You'll discover how to use clever tricks to sell things like cloud
        services and subscription-based software (SaaS). We'll teach you
        important skills like researching and finding potential customers,
        keeping track of everything with fancy tools like hubspot CRM, and
        making the most out of communication.
        <br />
        <br />
        In our live classes, you'll get to meet real experts from the industry
        and even try out different scenarios. It's not just about selling tech,
        it's also about building long-lasting relationships with businesses.
        You'll learn how to tell engaging stories and manage relationships like
        a pro!
      </>
    ),
  },

  courseOutlines: [
    {
      unitId: 1,
      unitTitle: "Introduction to Tech Sales",
      unitTag: "",
      unitDescription: `
      “Introduction to Tech Sales” is a course that provides an overview of the fundamentals of technology sales. 
      The course covers topics such as emerging technologies like cloud computing and cybersecurity, how to sell 
      to private and public companies, and a proven four-step methodology for success as a technology sales professional
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Architecture for the sales team",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle:
            "A sales development representative's (SDR) job description",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Responsibilities of an SDR: inbound vs. outbound",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Total customer experience",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Sales career path",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 2,
      unitTitle: "Pipeline Development",
      unitTag: "",
      unitDescription: `
      A thorough understanding of the crucial procedures involved in Sales Development Representative 
      (SDR) operations is intended to be provided by the "Pipeline Development" module. Any successful 
      sales team relies on a well-organized and maintained pipeline, therefore this module aims to 
      give learners the information and abilities needed to efficiently create and manage a sales pipeline.
        `,

      unitFeatures: [
        {
          featureIcon: Icon8,
          featureTitle: "Review the pipeline development process for SDR",
          featureDescription: ``,
        },
        {
          featureIcon: Icon9,
          featureTitle: "Define the terms hot, warm, and cold prospects",
          featureDescription: ``,
        },
        {
          featureIcon: Icon10,
          featureTitle: `Review procedure for grading prospects as "hot," "warm," and "cold"`,
          featureDescription: ``,
        },
        {
          featureIcon: Icon9,
          featureTitle: "Total Addressable Market (TAM) definition",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 3,
      unitTitle: "Sales Research",
      unitTag: ``,
      unitDescription: `
      Successful sales tactics are built on solid sales research. We will examine the critical facets of 
      conducting research in the context of sales in the "Sales Research Fundamentals" subject. You will 
      get the knowledge and abilities necessary to identify worthwhile prospects, judge their suitability, 
      and communicate with them successfully after completing this module. This lesson will assist you in 
      honing your research abilities and improving your sales effectiveness, whether you are a seasoned 
      sales professional or are just beginning your career.
          `,

      unitFeatures: [
        {
          featureIcon: Icon8,
          featureTitle: "Why conduct the research?",
          featureDescription: ``,
        },
        {
          featureIcon: Icon9,
          featureTitle: "Skills in advanced investigation",
          featureDescription: ``,
        },
        {
          featureIcon: Icon10,
          featureTitle:
            "Explaining the method employed to explore potential prospects",
          featureDescription: ``,
        },
        {
          featureIcon: Icon9,
          featureTitle: "Methods for assessing prospect suitability",
          featureDescription: ``,
        },
        {
          featureIcon: Icon8,
          featureTitle:
            "Utilizing research to evaluate and eliminate potential prospects",
          featureDescription: ``,
        },
        {
          featureIcon: Icon9,
          featureTitle: "Illustrating the process for prospect research",
          featureDescription: ``,
        },
        {
          featureIcon: Icon10,
          featureTitle:
            "Performing outreach via cold emails (Emphasizing Relevance, Value, and Inquiry - RVI)",
          featureDescription: ``,
        },
        {
          featureIcon: Icon9,
          featureTitle: "Utilizing LinkedIn for investigation",
          featureDescription: ``,
        },
        {
          featureIcon: Icon8,
          featureTitle: "Leveraging Google for research",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 4,
      unitTitle: "Sales Engagement Techniques",
      unitTag: ``,
      unitDescription: `Mastering good engagement tactics is critical in the fast-paced world of sales for creating 
      strong customer relationships and raising the odds of successful encounters. This session, "Sales Engagement 
      Techniques," is intended to provide sales professionals with the skills and tactics needed to engage with 
      prospects and clients confidently and persuasively.
      `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle:
            "Getting ready for an unexpected call by employing the WWW method",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Creating an engaging script",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle:
            "Leveraging the start of an unplanned call if your prospect doesn't answer (demonstration/example)",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle:
            "How to draft an email with RRR (Relevance, Reward, Request) in the subject line",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 5,
      unitTitle: "Sequencing, and Intro to Qualification Calls",
      unitTag: "",
      unitDescription: `
      This module focuses on the crucial initial steps in the sales process: sequencing 
      and conducting qualification calls. Participants will gain insights into why qualification 
      calls are pivotal in identifying potential leads, the essential components of a successful 
      call, and the decision-making process during the call. Additionally, this module will provide 
      practical guidance on creating impactful 60-second videos, emphasizing the WWW (What, why, What) 
      framework, as well as crafting compelling calls to action. The module also covers the post-call phase, 
      highlighting the distinction between sending a LinkedIn request and an email, post-RRR (Reason, Results, 
        Request) stage.
          `,

      unitFeatures: [
        {
          featureIcon: Icon4,
          featureTitle: "Why a qualification call is made",
          featureDescription: ``,
        },
        {
          featureIcon: Icon1,
          featureTitle: "A qualification call's components",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Making decisions on the call",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle:
            "Make a 60-second video's preparation notes using the WWW framework",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle:
            "Make a 60-second video that clearly states the call to action",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle:
            "After RRR, sending a LinkedIn request (and how this differs from sending an email)",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 6,
      unitTitle: "Qualification Call Planning",
      unitTag: "",
      unitDescription: `
      The "Qualification Call Planning" module is designed to equip sales professionals with 
      essential skills and strategies for conducting effective qualification calls. This module 
      focuses on best practices for qualification calls, emphasizing the art of storytelling as a 
      powerful tool to engage prospects and uncover critical information. Participants will learn 
      how to prepare for qualification calls, whether they are scheduled or impromptu, and will be 
      guided through the process of crafting compelling stories to enhance their sales approach.
          `,

      unitFeatures: [
        {
          featureIcon: Icon2,
          featureTitle: "Best practices for qualification calls",
          featureDescription: ``,
        },
        {
          featureIcon: Icon1,
          featureTitle: "Storytelling: What it is and what it looks like",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle:
            "How to get ready with qualification questions for both scheduled and impromptu calls",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle:
            "How to get ready for your call (the hero's journey) with relevant stories",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 7,
      unitTitle: "Qualification Call in Action: Opening",
      unitTag: ``,
      unitDescription: `
      In the "Qualification Call in Action: Opening" module, participants will learn the 
      crucial skills and techniques required to make a strong and effective opening during 
      both scheduled and unscheduled qualification calls. The opening phase of a call sets 
      the tone and lays the foundation for a successful interaction. Whether it's a planned 
      call or an unexpected one, mastering the opening is key to building rapport, establishing 
      trust, and guiding the conversation in the right direction.
            `,

      unitFeatures: [
        {
          featureIcon: Icon9,
          featureTitle: "ACE your opening on a scheduled call",
          featureDescription: ``,
        },
        {
          featureIcon: Icon10,
          featureTitle: "Introduce agenda on a scheduled call",
          featureDescription: ``,
        },
        {
          featureIcon: Icon8,
          featureTitle: "Opening your unscheduled call (ACE, Agenda, WWW)",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 8,
      unitTitle: "Qualification Call in Action: Diagnose and Prescribe",
      unitTag: ``,
      unitDescription: `In the dynamic world of sales, the Qualification Call (QC) is a 
      pivotal moment where potential clients and sales professionals engage in a dialogue 
      that can shape the trajectory of a deal. Successful QCs are driven by the ability to 
      diagnose the client's needs accurately and prescribe tailored solutions that resonate 
      with their challenges and goals. This module, "Qualification Call in Action: Diagnose 
      and Prescribe," delves into the art and science of mastering the QC process.
        `,

      unitFeatures: [
        {
          featureIcon: Icon3,
          featureTitle:
            "How to diagnose and prescribe using your QC preparation notes",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle:
            "Asking the correct questions during your qualifying call will help you diagnose",
          featureDescription: ``,
        },
        {
          featureIcon: Icon1,
          featureTitle: "Improve your QC by telling stories",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 9,
      unitTitle: "Qualification Call in Action: Close",
      unitTag: ``,
      unitDescription: `In this module, we will delve into the critical phase of closing a qualification 
        call effectively. The qualification call is a pivotal step in the sales process, where you determine 
        whether a potential prospect is a good fit for your product or service. To successfully close this 
        call, you need to bring together various elements, including the ACE (Agenda, Challenge, Expectations), 
        the diagnosis of the prospect's needs, and the prescription for how your solution can address those needs. 
        During this module, we will explore strategies and techniques for concluding your qualification calls with 
        confidence and purpose. We'll cover the nuances of closing both scheduled and unscheduled calls, 
        as each situation requires a slightly different approach.
          `,

      unitFeatures: [
        {
          featureIcon: Icon9,
          featureTitle:
            "Bringing together the ACE, agenda, diagnosis, and prescription to conclude your qualification calls",
          featureDescription: ``,
        },
        {
          featureIcon: Icon10,
          featureTitle: "How to close a scheduled vs. an unscheduled call",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 10,
      unitTitle: "Handling Objections and Rejections and Wrapping Up",
      unitTag: ``,
      unitDescription: `The "Handling Objections and Rejections and Wrapping Up" 
        module is designed to equip participants with the skills and strategies 
        needed to effectively navigate objections and rejections in a sales context. 
        This module addresses two critical aspects of the sales process: handling objections 
        to product or service offerings and managing situations where a potential sale is met 
        with rejection. Additionally, the module emphasizes the importance of thorough Quality 
        Control (QC) processes and provides guidance on post-QC follow-up procedures. Lastly, 
        the concept of sequencing in sales is explored to optimize the order and timing of 
        interactions for maximum impact.
            `,

      unitFeatures: [
        {
          featureIcon: Icon9,
          featureTitle: "Handling objections",
          featureDescription: ``,
        },
        {
          featureIcon: Icon10,
          featureTitle: "Handling rejection",
          featureDescription: ``,
        },
        {
          featureIcon: Icon8,
          featureTitle: "Following a QC, follow up",
          featureDescription: ``,
        },
        {
          featureIcon: Icon10,
          featureTitle: "A description of sequencing",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 11,
      unitTitle: "Sales Tools",
      unitTag: ``,
      unitDescription: `In the dynamic world of sales, staying ahead and maximizing 
        your efficiency is crucial to achieving success. This module, "Sales Tools," 
        is designed to equip you with essential resources and strategies to effectively 
        manage your customers, streamline your sales processes, and make data-driven decisions. 
        By the end of this module, you'll have a comprehensive understanding of various sales 
        tools that empower you to boost your sales productivity and drive revenue growth.
              `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle:
            "Managing customers and prospects with Customer Relationship Management (CRM) Software",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle:
            "Sales Engagement Platforms for personalizing reach to prospects",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Sales Analytics and Reporting Tools for insights",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Email Marketing and Automation for targeted messaging",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Lead Generation and Prospecting Tools",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle:
            "Sales Forecasting Software for setting sales targets and managing resources",
          featureDescription: ``,
        },
        {
          featureIcon: Icon1,
          featureTitle:
            "Proposal and Quoting Software for streamlining the process of creating and sending sales proposals",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 12,
      unitTitle: "Soft Skills for Sales",
      unitTag: ``,
      unitDescription: `The "Soft Skills for Sales" module is designed to equip sales professionals, 
        particularly Sales Development Representatives (SDRs), with essential non-technical skills crucial 
        for success in a dynamic sales environment. This module focuses on four key aspects: time management, 
        self-evaluation, rejection handling, and stress management. Participants will gain valuable insights 
        and practical techniques to enhance their effectiveness in building and nurturing client relationships.
            `,

      unitFeatures: [
        {
          featureIcon: Icon9,
          featureTitle: "Using time management strategies for success",
          featureDescription: ``,
        },
        {
          featureIcon: Icon10,
          featureTitle:
            "Learn how to be successful as an SDR by evaluating yourself",
          featureDescription: ``,
        },
        {
          featureIcon: Icon8,
          featureTitle: "Managing rejection",
          featureDescription: ``,
        },
        {
          featureIcon: Icon10,
          featureTitle: "Controlling stress",
          featureDescription: ``,
        },
      ],
    },
  ],

  courseCoaches: [
    // {
    //   coachId: 1,
    //   coachImage: Instructor1,
    //   coachName: "Josiah Yahaya",
    //   coachRole: "Senior Blockchain Engineer, Dedicated.Ai",
    // },
  ],

  learningModels: [
    {
      modelId: 1,
      modelIcon: LearnImage,
      modelTitle: "Hands On Training",
      modelDescription:
        "Practical sessions with lots of collaboration and learnings",
    },
    {
      modelId: 2,
      modelIcon: SupportImage,
      modelTitle: "Virtual Classes",
      modelDescription:
        "A 12 weeks experiential learning and hands-on Instructor-led virtual classes.",
    },
    {
      modelId: 3,
      modelIcon: BuildingImage,
      modelTitle: "Business Case-focused",
      modelDescription:
        "Work on real-life projects by applying what you learn to solve related business problems.",
    },
    {
      modelId: 4,
      modelIcon: AlunmiImage,
      modelTitle: "Peer-to-Peer Sessions",
      modelDescription:
        "Share knowledge with other fellows and gain multi-dimensional perspectives of problem-solving",
    },
  ],

  studentTestimonies: [
    {
      id: 2,
      linkedIn: "",
      image: Testimony2,
      firstname: "Ajibola",
      lastname: "Liyide",
      company: "Internal, External and Media Relations",
      testimony: `
        The Utiva training with Utiva has been challenging and inspiring. Challenging 
        because it is at the same time as the re-branding project in my office. Inspiring because 
        I have learnt a lot so far. The key point is that the user experience is the most 
        important factor to add value and provide solutions. 
        `,
    },
  ],

  portofolio: {
    title: "Build Solutions around Real-life Business Cases",
    description: `
    Through the Utiva Tech Sales Bootcamp, you will learn what 
    makes competent Tech Sales and work on real-world projects 
    developed by industry experts. Every week in your Utiva Tech Sales Bootcamp classes, 
    you'll be provided with clear actionable steps to iteratively develop your 
    project. With real-world projects and immersive content built in partnership 
    with top-tier companies, you’ll master the skills companies require. 
      `,
    name: "James Miles",
    // image: PortfolioUserAvatar,
    // portfolioImage: PortfolioImage,
  },

  certification: {
    title: "Earn a Utiva Tech Sales Bootcamp Certification",
    description: `
    Upon completing Utiva's Tech Sales Bootcamp, you'll receive an 
    industry-recognized, professional Tech Sales Program certification to 
    share with your network and showcase all that you've 
    learned. Utiva certificates are formatted for sharing on LinkedIn 
      `,
  },

  // videoTestimonial: "https://youtu.be/TQrD6jyYqxs",

  otherCourses: [
    {
      id: 2,
      courseTitle: "Data Analytics Bootcamp",
      courseDescription: `This program is designed to help you apply the important ML techniques for solving 
      real business problems and also help you make key data-driven decisions for business growth.  `,
      courseUrl: "/courses/data-analytics-bootcamp",
    },
  ],
};
